/* eslint-disable array-callback-return */
import React, { useEffect, useState, useRef } from 'react';
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import ReactApexChart from "react-apexcharts";
import { NavLink, Link } from "react-router-dom";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { Image, Dropdown, Menu } from "antd";
import { currencyFormat, currencyFormatInt, downloadImageCommon, exportChatFile } from "../../../../helpers/utilities";
import { SelectedIcon, UnSelectedIcon } from "../Icons/selectedIcon";
import useMediaQuery from '@mui/material/useMediaQuery';
import { AESEncrypt } from "../../../../helpers/Crypto";


export const LastDays = (props) => {
    const { title, salesDashboardDetails } = props;
    const lastDays = useRef(null);
    const classes = customStyles();
    const [datas, setDatas] = useState([]);
    const [days, setDays] = useState(30)
    const mobileDevice = useMediaQuery('(min-width:1300px)');

    const handleChange = (value) => {
        setDatas(salesDashboardDetails[value]);
        if (value === 'customer_sales_120') {
            setDays(120);
        } else if (value === 'customer_sales_300') {
            setDays(300);
        } else {
            setDays(30);
        }
    }

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(lastDays.current, title, type)
        }
    }

    const exportFile = () => {
        let newHead = [['Name', 'Invoice Amount', 'Balance Due']];

        datas.length > 0 && datas.map((data, i) => {
            newHead[i + 1] = [data.name, data.invoiceAmount, data.balanceAmount];
        });
        exportChatFile(title, newHead);
    }

    const chartData = {
        chart: {
            type: 'radialBar',
            toolbar: {
                show: false
            }
        },
        colors: [
            function ({ value, seriesIndex, w }) {
                if (value < 51) {
                    return '#ff0000';
                } else if (value < 75) {
                    return '#ffa539';
                } else {
                    return '#16c88b'
                }
            }
        ],
        plotOptions: {
            radialBar: {
                startAngle: -180,
                endAngle: 169,
                hollow: {
                    margin: 0,
                    size: '70%',
                    background: '#fff',
                    image: undefined,
                    imageOffsetX: 0,
                    imageOffsetY: 0,
                    position: 'front',
                    dropShadow: {
                        enabled: true,
                        top: 3,
                        left: 0,
                        blur: 4,
                        opacity: 0.24
                    }
                },
                track: {
                    strokeWidth: '100%',
                    background: 'transparent',
                    margin: 0, // margin is in pixels
                    dropShadow: {
                        enabled: true,
                        top: -3,
                        left: 0,
                        blur: 4,
                        opacity: 0.2
                    }
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: "horizontal",
                        shadeIntensity: 0.8,
                        gradientToColors: undefined,
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 50, 100],
                        colorStops: []
                    },
                },
                dataLabels: {
                    show: true,
                    name: {
                        offsetY: 11,
                        show: true,
                        color: '#8a8a8e',
                        fontWeight: "normal",
                        fontFamily: "Roboto",
                        fontSize: '8px'
                    },
                    value: {
                        formatter: function (val) {
                            return parseInt(val) + '%';
                        },
                        offsetY: -15,
                        color: '#000',
                        fontSize: '13px',
                        fontWeight: "500",
                        fontFamily: "Roboto",
                        show: true,
                    }
                }
            }
        },
        stroke: {
            lineCap: 'round'
        },
        labels: ['Settled'],
    }

    useEffect(() => {
        if (salesDashboardDetails) {
            setDatas(salesDashboardDetails['customer_sales_30']);
        }
    }, [salesDashboardDetails]);

    return (
        <div ref={lastDays} className={clsx(classes.totalChartDiv, { [classes.mobileDevice]: !mobileDevice })}>
            <div className={clsx(classes.monthlyDivTitle, classes.bold)}><span>{title}</span>
                {
                    !mobileDevice && <br />
                }
                <span className={classes.lastDays}>{`Last ${days} days`}</span>
                <span className={classes.lastDaysRadio}>
                    <RadioGroup
                        row
                        defaultValue={"customer_sales_30"}
                        onChange={(e) => handleChange(e.target.value)}>
                        <FormControlLabel value="customer_sales_30" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="30" />
                        <FormControlLabel value="customer_sales_120" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="120" />
                        <FormControlLabel value="customer_sales_300" control={<Radio
                            checkedIcon={<UnSelectedIcon />}
                            icon={<SelectedIcon />}
                        />} label="300" />
                    </RadioGroup>
                </span>
                <span className={classes.hamburgerMenu}>
                    <Dropdown
                        placement="bottomLeft"
                        trigger={['click']}
                        overlay={
                            <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                            </Menu>
                        }>
                        <Image src={hamburgerMenu} preview={false} />
                    </Dropdown>
                </span>
            </div>
            <div className={clsx(classes.lastDaysContent, classes.overFolwBigContent, classes.scrollBarLight)} style={{ height: "calc(100% - 32px)" }}>
                {
                    datas.length > 0 ? datas.map((data, i) => (
                        <div className={classes.daysRow} key={i}>
                            <Link to={`sales/transactions/${AESEncrypt(data?.id)}/invoice-history`}
                                className={clsx(classes.daysRowTitle, classes.bold)}>{data.name}</Link>
                            <div className={clsx(classes.daysRowContent)}>
                                <div className={classes.daysRowContentInner}>
                                    <div className={classes.daysRowContentTitle}>Invoice Amount</div><div className={clsx(classes.daysRowText, classes.bold)}>₹ {currencyFormatInt(data.invoiceAmount)}</div>
                                </div>
                                <div className={clsx(classes.daysRowContentInner, classes.textAlignRight)}>
                                    <div className={classes.daysRowContentTitle}>Balance Due</div><div className={clsx(classes.daysRowText, classes.bold)}>₹ {currencyFormat(data.balanceAmount)}</div>
                                </div>
                                <span className={classes.daysRowCircle}>
                                    <ReactApexChart height="68" options={chartData} series={[parseInt(((data.invoiceAmount - data.balanceAmount) / data.invoiceAmount) * 100) !== 0 ? (((data.invoiceAmount - data.balanceAmount) / data.invoiceAmount) * 100) : 0.2]} type="radialBar" />
                                </span>
                            </div>
                        </div>
                    )) : 'No results found'
                }
            </div>
        </div>

    )
}